import React, { useState } from 'react'
import { Col, Modal, Row } from 'antd'
import './CreateBucketVersionModal.scss'
import Input from '../inputs/Input'

const CreateBucketVersionModal = ({
  visible,
  onOk,
  onCancel,
  loading
}) => {
  const [versionName, setVersionName] = useState('')
  return (
    <Modal
      title='CREATE BUCKET VERSION'
      visible={visible}
      onOk={() => {
        onOk({
          versionName,
          setVersionName
        })
      }}
      onCancel={() => {
        onCancel()
        setTimeout(() => {
          setVersionName('')
        }, 500)
      }}
      className='general-modal create-bucket-version-modal'
      okButtonProps={{
        loading,
        disabled: !versionName
      }}
      okText='SAVE'
      // width='calc(100vw - 150px)'
    >
      <div className='create-bucket-version-wrapper'>
        <Row className='basic-date-picker' gutter={[24, 24]}>
          <Col span={24}>
            <Input
              title='Version Name'
              isRequired
              placeholder='Enter Version Name'
              limit={40}
              inputName='title'
              value={versionName}
              handleChange={(event) => setVersionName(event.target.value)}
            />
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default CreateBucketVersionModal
